import { IBomPart } from 'bom/types';
import { mapCreateCustomerQuoteForm } from 'quotes/components/CustomerQuoteUpsert';
import { mapCreateVendorQuoteForm } from 'quotes/components/VendorQuoteUpsert';
import { QuoteEntityType, QuoteType } from 'quotes/enums';
import { IAddBomPartsToNewQuoteData, IAddBomPartsToQuoteData, IBaseQuote } from 'quotes/types';

import {
  ICreateCustomerQuoteFromJobForm,
  ICreateVendorQuoteFromJobForm,
} from './Steps/SelectItemsToCopy/types';

interface IProps {
  targetQuote?: IBaseQuote | null;
  toQuoteType: QuoteType;
  data: ICreateCustomerQuoteFromJobForm | ICreateVendorQuoteFromJobForm;
  jobParts: IBomPart[];
  isAlternateVersionEnabled?: boolean;
}

export const mapAddBomPartsToQuoteForm = ({
  targetQuote = null,
  toQuoteType,
  data,
  jobParts,
  isAlternateVersionEnabled = false,
}: IProps): IAddBomPartsToQuoteData | IAddBomPartsToNewQuoteData => {
  const components = jobParts.map((jobPart: IBomPart) => jobPart.componentId);
  const componentsData = jobParts.reduce(
    (acc, jobPart: IBomPart) => ({
      ...acc,
      [jobPart.componentId]: {
        quantity: jobPart.quantity,
        uom: jobPart.uom,
      },
    }),
    {} as { [componentId: number]: { quantity: number; uom: string } }
  );

  if (targetQuote?.id) {
    return {
      components,
      componentsData,
      targetQuoteId: targetQuote.id,
    };
  }

  const targetQuoteMapData =
    QuoteType.VENDOR === toQuoteType
      ? mapCreateVendorQuoteForm(data as ICreateVendorQuoteFromJobForm, QuoteEntityType.QUOTE).quote
      : mapCreateCustomerQuoteForm(
          data as ICreateCustomerQuoteFromJobForm,
          QuoteEntityType.QUOTE,
          isAlternateVersionEnabled
        ).quote;

  return {
    components,
    componentsData,
    targetQuote: targetQuoteMapData,
  };
};
